
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalNotification as ObiBatteryHorizontalNotificationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-notification.js';
 
 
 

 
 export const ObiBatteryHorizontalNotification = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-notification',
   elementClass: ObiBatteryHorizontalNotificationElement,
   events: {
     
   }
  });
 
 